import { render, staticRenderFns } from "./MedPlan.vue?vue&type=template&id=5fc02ca1&scoped=true"
import script from "./MedPlan.vue?vue&type=script&lang=js"
export * from "./MedPlan.vue?vue&type=script&lang=js"
import style0 from "./MedPlan.vue?vue&type=style&index=0&id=5fc02ca1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc02ca1",
  null
  
)

export default component.exports